// react
import { Modal } from "antd";

// redux
import { showAppModal } from "~/redux/actions/app";

// utils
import { isWechatBrowser } from "~/utils/wechat";

const isWechat = isWechatBrowser();

/**
 * 评论「电一下」的统一入口校验：未登录弹登录框，电量不足弹充值引导，
 * 通过校验后打开评论充电弹窗。
 *
 * @param {object} options
 * @param {object} options.comment 要充电的评论
 * @param {object} options.user 当前登录用户
 * @param {string} options.token 登录 token
 * @param {Function} options.showAppModal dispatch 的 showAppModal
 * @param {object} options.router next/router 实例，微信内跳转个人资料页用
 * @param {Function} [options.onCharged] 充电成功回调，参数为充电后的评论数据
 */
export const openCommentChargeDialog = ({
  comment,
  user,
  token,
  showAppModal,
  router,
  onCharged,
}) => {
  if (!token) {
    showAppModal("PhoneSigninModal");
    return;
  }

  if (user && user.ele >= 1) {
    // 当我的电量大于1(充电所需最小电量值)时，打开充电窗口。
    showAppModal("CommentChargeModal", { comment, onCharged });
    return;
  }

  // 当我的电量小于1(充电所需最小电量值)时，提示电量不足。
  Modal.confirm({
    title: "电量余额不足",
    okText: "去充电",
    closable: true,
    content: (
      <div>
        <p>哎呀，您的电量不足啦！可付费充电，支持社区发展哦：）</p>
        <p>
          <a
            href="https://eleduck.com/posts/6GzfGe"
            className="text-primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            电量的作用及如何获取电量？
          </a>
        </p>
      </div>
    ),
    onOk() {
      if (isWechat) {
        router.push({
          pathname: "/profile/info",
          query: { redirectUrl: router.asPath },
        });
      } else {
        showAppModal("TopUpModal");
      }
    },
  });
};
